import React, { useContext} from "react";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Assets/Image/new.PNG";
import { UserContext } from "../../context/User/Context";
import axios from "axios";

export default function Navbar() {
  let lis=document.querySelectorAll('.navbar-nav .nav-item')
  let ToggleBTN=document.querySelector('.navbar-toggler')
  let navbarcollapse=document.querySelector('.navbar-collapse')

  function removeToggleBTN(){
    ToggleBTN.classList.remove('collapsed');
    ToggleBTN.setAttribute("aria-expanded", "false");
    navbarcollapse.classList.remove('show');
  }
  lis.forEach((item) => {
    item.addEventListener('click', removeToggleBTN)
  })

  let headers = {
    token: localStorage.getItem("userToken"),
  };
  let { userToken, setUserToken } = useContext(UserContext);
  let navigate = useNavigate();

  async function logOut() {
    let response = await axios
      .put("https://vehex-production.up.railway.app/user/logout", null, {
        headers: headers,
      })
      .catch((err) => {
        // alert(err.response.data.message);
      });

    if (response.data.message === "Logged out successfully.") {
      localStorage.removeItem("counter");
      localStorage.removeItem("userToken");
      localStorage.removeItem("role");

      setUserToken(null);
      navigate("/login");
    }
  }

  function addVehicle() {
    let token = localStorage.getItem("userToken");

    if (!token) {
      navigate("/login");
    } else {
      navigate("/addVehicle");
    }
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-second-color">
        <div className=" container-fluid ">
          <Link className="navbar-brand" onClick={()=>removeToggleBTN()} to="/">
            <img src={Logo} alt="Logo" width={150} />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i class="fa-solid fa-bars text-white fs-3"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-lg-0 left-links">
              <li
                className="nav-item me-1"
                onClick={() => window.location.reload()}
              >
                <Link
                  className="nav-link tex-black fs-6 transition"
                  to="package"
                >
                  <span className="fs-6 fw-500">Packages</span>
                </Link>
              </li>
              <li
                className="nav-item me-1"
                onClick={() => window.location.reload()}
              >
                <Link
                  className="nav-link tex-black fs-6 transition"
                  to="products"
                >
                  <span className="fs-6 fw-500">Products</span>
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link
                  className="nav-link tex-black fs-6 transition"
                  to="about"
                >
                  <span className="fs-6 fw-500">About</span>
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link
                  className="nav-link tex-black fs-6 transition"
                  to="contact"
                >
                  <span className="fs-6 fw-500">Contact</span>
                </Link>
              </li>
              <li className="nav-item me-1">
                <Link
                  className="nav-link tex-black fs-6 transition"
                  to="howtoorder"
                >
                  <span className="fs-6 fw-500">How to Order</span>
                </Link>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto mb-lg-0 right-links">
              {localStorage.getItem('role') === "admin" ? (
                <li className="nav-item me-1 ">
                  <Link
                    className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center "
                    to="/dashboard"
                  >
                    <i class="fa-solid fa-laptop main-color"></i>
                    <span className="fs-6 fw-500 arrow">Dashboard</span>
                  </Link>
                </li>
              ) : (
                <li className="nav-item me-1 d-none">
                  <Link
                    className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center "
                    to="/dashboard"
                  >
                    <i class="fa-solid fa-laptop main-color"></i>
                    <span className="fs-6 fw-500 arrow">Dashboard</span>
                  </Link>
                </li>
              )}

              <li className="nav-item me-1 ">
                <Link
                  className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center "
                  to="addVehicle"
                >
                  <i class="fa-solid fa-car main-color"></i>
                  <span
                    className="fs-6 fw-500 arrow"
                    onClick={() => addVehicle()}
                  >
                    Add vehicle
                  </span>
                </Link>
              </li>

              <li className="nav-item me-1"
              onClick={() => window.location.reload()}>
                <Link
                  className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center transition"
                  to="cart"
                >
                  <i class="fa-solid fa-cart-shopping main-color"></i>

                  <span className="fs-6 fw-500 position-relative">
                    Cart
                  </span>
                </Link>
              </li>
              {userToken !== null ? (
                <>
                  <li className="nav-item ">
                    <Link
                      className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center transition"
                      to="login"
                    >
                      <i class="fa-solid fa-right-to-bracket main-color"></i>
                      <span className="fs-6 fw-500" onClick={() => logOut()}>
                        Logout
                      </span>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item me-1">
                    <Link
                      className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center transition"
                      to="login"
                    >
                      <i class="fa-solid fa-right-to-bracket main-color"></i>
                      <span className="fs-6 fw-500">Login</span>
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      className="nav-link fs-6 right-links tex-black d-flex flex-column align-items-center transition"
                      to="register"
                    >
                      <i class="fa-solid fa-user main-color"></i>
                      <span className="fs-6 fw-500">Register</span>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
